import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { auth, db, createUserWithEmailAndPassword } from '../firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { sendEmailVerification, updateProfile } from 'firebase/auth';
import { claimMembership, normalizeEmail } from '../utils/membership';
import { useTranslation } from '../contexts/LanguageContext';
import '../App.css';

const Register = ({ setUser }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [claimedTeams, setClaimedTeams] = useState([]);
  const history = useHistory();
  const { t } = useTranslation();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await updateProfile(user, { displayName: name.trim() });
      await sendEmailVerification(user);
      setEmailSent(true);

      const normalized = normalizeEmail(user.email || email);
      try {
        await setDoc(
          doc(db, 'users', user.uid),
          {
            uid: user.uid,
            email: normalized,
            displayName: name.trim(),
            createdAt: serverTimestamp(),
          },
          { merge: true }
        );
      } catch (profileErr) {
        console.warn('Nisam mogao spremiti users/{uid} zapis:', profileErr);
      }

      try {
        const claimed = await claimMembership(user.uid, normalized, name.trim());
        setClaimedTeams(claimed);
      } catch (claimErr) {
        console.warn('Claim pri registraciji nije uspio:', claimErr);
      }

      setUser(user);
      // Ne preusmjeravamo odmah - korisnik mora prvo verificirati email
      // i tada će onAuthStateChanged u App.js ga postaviti kao ulogiranog.
      // No ako želi, može kliknuti link ispod da ode na login ekran.
      setTimeout(() => history.push('/login'), 2500);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="container">
      <h2>{t('auth.registerTitle')}</h2>
      {error && <p className="error-message">{error}</p>}

      {!emailSent ? (
        <form onSubmit={handleRegister} method="post" action="#" aria-label={t('auth.registerAria')}>
          <label htmlFor="register-name" className="sr-only">{t('auth.nameLabel')}</label>
          <input
            id="register-name"
            name="name"
            type="text"
            autoComplete="name"
            placeholder={t('auth.namePlaceholder')}
            className="input-field"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <label htmlFor="register-email" className="sr-only">{t('auth.emailLabel')}</label>
          <input
            id="register-email"
            name="email"
            type="email"
            autoComplete="username"
            inputMode="email"
            spellCheck="false"
            autoCapitalize="none"
            autoCorrect="off"
            placeholder="Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label htmlFor="register-password" className="sr-only">{t('auth.passwordLabel')}</label>
          <input
            id="register-password"
            name="new-password"
            type="password"
            autoComplete="new-password"
            minLength={6}
            placeholder={t('auth.passwordLabel')}
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">{t('auth.registerSubmit')}</button>
        </form>
      ) : (
        <div>
          <p>{t('auth.verificationSent')}</p>
          {claimedTeams.length > 0 && (
            <p style={{ color: 'var(--accent, #00f5a0)', marginTop: 12 }}>
              {t('auth.welcomeTeamsStart')} {claimedTeams.length}{' '}
              {claimedTeams.length === 1 ? t('auth.waitingTeam') : t('auth.waitingTeams')}
            </p>
          )}
          <p style={{ marginTop: 16 }}>
            <Link to="/login">{t('auth.goToLogin')}</Link>
          </p>
        </div>
      )}
    </div>
  );
};

export default Register;
